import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import FormSectionContainer from '@client/containers/formSectionContainer/FormSectionContainer';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import InputGroup from '@client/components/formComponents/inputGroup/InputGroup';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import { isSignedInWithEmail } from '@client/redux/user/userReducer';
import styles from './formAccountInformation.scss';

class FormAccountInformation extends PureComponent {
  showMyInfoFormSection = () => {
    const { userInfo } = this.props;
    const firstName = getIn(userInfo, 'given_name');
    const lastName = getIn(userInfo, 'family_name');
    const email = getIn(userInfo, 'email');
    const phonenumber = getIn(userInfo, 'phonenumber');
    const zipcode = getIn(userInfo, 'zipcode');
    const city = getIn(userInfo, 'city');
    const address = getIn(userInfo, 'address');

    return (
      !firstName ||
      !lastName ||
      !email ||
      !phonenumber ||
      !zipcode ||
      !city ||
      !address
    );
  };
  render() {
    const { className, formProps, userInfo } = this.props;

    const signedInWithEmail = isSignedInWithEmail(userInfo);

    const formValues = formProps.values;
    const formErrors = formProps.errors;

    return (
      <form
        onSubmit={formProps.handleSubmit}
        className={`${styles.formAccountInformation}${
          className ? ` ${className}` : ''
        }`}
      >
        {this.showMyInfoFormSection && (
          <FormSectionContainer
            className={styles.formSectionContainerProp}
            title={'Kontaktuppgifter'}
          >
            <div className={styles.subTitle}>
              Här kan du uppdatera dina uppgifter.
            </div>
            <div className={styleHelper.grid12}>
              <div>
                <InputGroup
                  labelText={'Förnamn'}
                  name={'firstName'}
                  value={valueOrEmptyStr(formValues.firstName)}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  errorLabel={formErrors.firstName}
                />
              </div>
              <div>
                <InputGroup
                  labelText={'Efternamn'}
                  name={'lastName'}
                  value={valueOrEmptyStr(formValues.lastName)}
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  errorLabel={formErrors.lastName}
                />
              </div>
            </div>
            <div className={styles.formInputContainer}>
              {signedInWithEmail && (
                <div>
                  <InputGroup
                    labelText={'E-post'}
                    name={'email'}
                    value={valueOrEmptyStr(formValues.email)}
                    onChange={formProps.handleChange}
                    onBlur={formProps.handleBlur}
                    errorLabel={formErrors.email}
                  />
                </div>
              )}
            </div>
            <div className={`${styleHelper.flexRow} ${styles.buttonContainer}`}>
              <button
                className={`${styleHelper.btnPrimaryMd} ${styles.button}`}
              >
                Uppdatera
              </button>
            </div>
          </FormSectionContainer>
        )}
      </form>
    );
  }
}

FormAccountInformation.propTypes = {
  userInfo: ImmutablePropTypes.map,
  formProps: PropTypes.object,
  className: PropTypes.string,
};
export default FormAccountInformation;
